import React from 'react'
import { IconsModel } from './iconsModel'

const SvgFamily = (
	{
		color,
		width = 65,
		height = 46
	}: IconsModel
) => (
	<svg width={width} height={height} viewBox={`0 0 65 42`}>
		<g transform="translate(0.25 0.25)">
			<g>
				<g>
					<path
						d="M66.233,52.425a7.453,7.453,0,1,1,7.453-7.453A7.461,7.461,0,0,1,66.233,52.425Zm0-13.338a5.885,5.885,0,1,0,5.885,5.885A5.891,5.891,0,0,0,66.233,39.087Z"
						transform="translate(-52.111 -37.519)"
						fill={color}
						stroke={color}
						strokeWidth="0.5"
					/>
					<path
						d="M204.411,52.425a7.453,7.453,0,1,1,7.453-7.453A7.462,7.462,0,0,1,204.411,52.425Zm0-13.338a5.885,5.885,0,1,0,5.885,5.885A5.891,5.891,0,0,0,204.411,39.087Z"
						transform="translate(-168.617 -37.519)"
						fill={color}
						stroke={color}
						strokeWidth="0.5"
					/>
					<path
						d="M44.5,168.727H20.379a4.123,4.123,0,0,1-4.119-4.119V151.271a7.462,7.462,0,0,1,7.453-7.453h2.12l.226.392a4.989,4.989,0,0,0,8.645,0l.227-.392h2.12a7.462,7.462,0,0,1,7.453,7.453ZM23.713,145.386a5.891,5.891,0,0,0-5.885,5.885v13.338a2.553,2.553,0,0,0,2.55,2.55H42.935V151.271a5.891,5.891,0,0,0-5.885-5.885H35.817a6.556,6.556,0,0,1-10.87,0Z"
						transform="translate(-16.26 -127.146)"
						fill={color}
						stroke={color}
						strokeWidth="0.5"
					/>
					<path
						d="M222.288,168.728H208.95V167.16h13.338a2.553,2.553,0,0,0,2.55-2.55V151.272a5.893,5.893,0,0,0-5.461-5.869A6.557,6.557,0,0,1,208.271,145l1.358-.785a4.989,4.989,0,0,0,8.646,0l.226-.391h.452a7.461,7.461,0,0,1,7.453,7.453v13.338A4.123,4.123,0,0,1,222.288,168.728Z"
						transform="translate(-178.156 -127.147)"
						fill={color}
						stroke={color}
						strokeWidth="0.5"
					/>
					<path
						d="M212.6,148.819"
						transform="translate(-181.805 -131.363)"
						fill={color}
						stroke={color}
						strokeWidth="0.5"
					/>
					<path
						d="M222.288,168.728H208.95V167.16h13.338a2.553,2.553,0,0,0,2.55-2.55V151.272a5.893,5.893,0,0,0-5.461-5.869A6.557,6.557,0,0,1,208.271,145l1.358-.785a4.989,4.989,0,0,0,8.646,0l.226-.391h.452a7.461,7.461,0,0,1,7.453,7.453v13.338A4.123,4.123,0,0,1,222.288,168.728Z"
						transform="translate(-178.156 -127.147)"
						fill={color}
						stroke={color}
						strokeWidth="0.5"
					/>
				</g>
			</g>
			<path
				d="M218.541,162.07h-9.773v-1.149h9.773a1.871,1.871,0,0,0,1.868-1.869V149.28a4.318,4.318,0,0,0-4-4.3,4.8,4.8,0,0,1-8.137-.3l.995-.575a3.656,3.656,0,0,0,6.335,0l.166-.287h.331a5.467,5.467,0,0,1,5.461,5.461v9.773A3.021,3.021,0,0,1,218.541,162.07Z"
				transform="translate(-157.021 -120.489)"
				fill={color}
				stroke={color}
				strokeWidth="1"
			/>
			<path
				d="M202.935,49.472a5.977,5.977,0,1,1,5.977-5.977A5.983,5.983,0,0,1,202.935,49.472Zm0-10.7a4.719,4.719,0,1,0,4.719,4.719A4.724,4.724,0,0,0,202.935,38.777Z"
				transform="translate(-147.708 -28.566)"
				fill={color}
				stroke={color}
				strokeWidth="0.75"
			/>
		</g>
	</svg>
)

export default SvgFamily
